export default (): JSX.Element => {
    const styles = {
        'display': 'none'
    }
    return (<div style={styles}></div>)
}
